export enum EquipmentStatuses {
    WithClient = "with_client",
    WithClientLongTerm = "with_client_long_term",
    Available = "available",
    Maintenance = "maintenance",
    ToCollect = "to_collect",
    UsageEnded = "usage_ended",
    Reserved = "reserved"
}

export const equipmentStatusesValues = Object.values(EquipmentStatuses);

export function isWithClientFamily(status: EquipmentStatuses | null | undefined): boolean {
    return status === EquipmentStatuses.WithClient || status === EquipmentStatuses.WithClientLongTerm;
}
